import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { environment } from '../../../../environments/environment';
import { TranslateService } from "@ngx-translate/core";
import { CustomerService } from "../../services/customer.service";
import { FileUploadConstants } from "../../constants/file-upload.constants";
import { ReportService } from "../../services/report.service";
import { CommonService } from "../../../shared/services/common.service";
import { NotificationType } from "../../enums/notification-types.enum";
import { DeliveryPreference, MemberLevel, OrderTypeTitle, } from '../../common/enumerations';
import { OrderTypeValues, DelivaryOptionType } from '../../common/constants';
import { MemberTypeEnum } from "../../enums/member-type.enum";
import { StatusConstants } from "../../constants/status.constants";
import { DatePipe } from "@angular/common";
import { DateConstants } from "../../constants/date.constants";
import { DistributorIdFormatPipe } from "../../../common/pipes/distributor-id-format.pipe";
import { StoreConfig } from "../../../shared/interface/StoreConfig.interface";
import { CurrencyTransformPipe } from "../../../common/pipes/currency-format.pipe";
import { moment } from "ngx-bootstrap/chronos/test/chain";

@Component({
    selector: 'app-bsn-reports',
    templateUrl: '../../templates/template1/views/reports/bsn-reports.component.html',
    styleUrls: [
        '../../templates/template1/themes/default/less/bsn-reports.less'
    ],
    providers: [DistributorIdFormatPipe, CurrencyTransformPipe]
})

export class BsnReportsComponent implements OnInit{

    @Input() fromDate: string;
    @Input() toDate: string;
    @Input() storeId: [number];
    @Output() isLoadedData = new EventEmitter<boolean>();
    @Output() addFavoriteEvent = new EventEmitter<boolean>();
    @Input() storeInfo: StoreConfig;
    @Input()countryName:string
    pageSizes = [50, 100, 150, 200];
    pageNumber: number = 1;
    pageSize: number = 50;
    pageCount: number = 0;
    currentDate = new Date();
    excelIconUrl = environment.cdnURL + '/flpi/images/ms_excel.ico';
    printIconUrl = environment.cdnURL + '/flpi/images/print_icon.png';
    bsnReports = null;
    allOrdersReport = null;
    isResponseError = false;
    isLoading = false;
    isAllOrdersReportLoading = false;
    isShowReport = true;
    csvType = FileUploadConstants.CSV_FILE_EXTENSION;
    printType = FileUploadConstants.PRINT;
    
    
    constructor(
        private _translateService: TranslateService,
        private _customerservice: CustomerService,
        private _reportService: ReportService,
        private _commonService: CommonService,
        private _datePipe: DatePipe,
        private distributorFormatPipe: DistributorIdFormatPipe,
        private _currencyPipe: CurrencyTransformPipe
    ) { }

    ngOnInit(): void {
        // this.getBsnReport();
        this.exportFile('csv');
    }

 /**
     * To get bsn reports
     * @returns void
     */
  getBsnReport(): void {
    this.isLoading = true;
    this._reportService.getBsnReport(this.storeId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, false).subscribe(response => {
        if (response && response.content) {
            response.content.forEach((element) => {
                if (element.createdDate) {
                  element.createdDate = this.getUtcDate(element.createdDate);
                }
                
              });
            this.bsnReports = response.content;
            this.isLoading = false;
            this.isResponseError = false;
            this.pageCount = response.totalCount;
            this.isLoadedData.emit(true);
           
        }
        else if (response && response.status && response.status.code === 504) {
            const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.setDefaultValues();
        }
        else {
            this.setDefaultValues();
        }
    }, (error) => {
        if(error.status == 504 || (error.name && error.name.toLowerCase() == 'typeerror')){
            const message: any = this._translateService.get('reports.Sorry It seems like you selected wider date range Please select the minimum date range and try again');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.setDefaultValues();
        }
        else{
            const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
            this._commonService.createNotification('', message.value, NotificationType.ERROR);
            this.setDefaultValues();
        }
    });
}

/**
     * To Set Default Values
     */
 setDefaultValues(): void {
    this.bsnReports = null;
    this.isLoading = false;
    this.isResponseError = true;
    this.pageCount = 0;
    this.isLoadedData.emit(true);
}

/**
     * To load orders report
     * @returns void
     */
 loadOrdersReports(): void {
    this.isShowReport = true;
    this.getBsnReport();
}

/**
* To change page size
* @param  {number} pageSize
* @returns void
*/
pageSizeChange(pageSize: number): void {
    if (pageSize) {
        this.pageNumber = 1;
        this.pageSize = pageSize;
        this.getBsnReport();
    }
}

/**
 * To change page number
 * @param  {number} pageNumber
 */
pageChange(pageNumber: number) {
    this.pageNumber = pageNumber;
    this.getBsnReport();
}

/**
     * To emit add favorite event to parent component
     * @returns void
     */
 addToFavorite(): void {
    this.addFavoriteEvent.emit(true);
}

getUtcDate(timeStamp: any): string {
    if (typeof (timeStamp) == 'number') {
      timeStamp = moment.utc(timeStamp).toISOString();
    }
    if (typeof (timeStamp) == 'string') {
      if (timeStamp && timeStamp.indexOf('T') > -1 && timeStamp.indexOf('.') > -1) {
        timeStamp = timeStamp.split('.')[0];
      }
    }
    timeStamp = timeStamp.replace('T',' ');
    return timeStamp;
  }

/**
     * To Export The file
     */
 exportFile(type): void {
    // if (this.allOrdersReport && this.allOrdersReport.length > 0) {
    //     this.download(type);
    // } else {
    //     this.fetchAllOrdersReport(type);
    // }
    this.fetchAllOrdersReport(type);
}

/**
     * To Fetch all orders report data from service
     */
 fetchAllOrdersReport(type): void {
    this.isAllOrdersReportLoading = true;
    this.isLoading = true;
    this._reportService.getBsnReport(this.storeId, this.fromDate, this.toDate, this.pageNumber, this.pageSize, true).subscribe(response => {
        if (response) {
            this.isAllOrdersReportLoading = false;
            response.content.forEach((element) => {
                if (element.createdDate) {
                  element.createdDate = this.getUtcDate(element.createdDate);
                }
                
              });
            this.allOrdersReport = response.content;
            this.bsnReports = response.content;
            this.isLoading = false;
            this.isResponseError = false;
            this.pageCount = response.totalCount;
            this.isLoadedData.emit(true);
            this.download(type);
        } else {
            this.isAllOrdersReportLoading = false;
            this.allOrdersReport = null;
            this.setDefaultValues();
        }
    }, (error) => {
        const message: any = this._translateService.get('reports.Something Went Wrong, Please try again after some time');
        this._commonService.createNotification('', message.value, NotificationType.ERROR);
        this.allOrdersReport = null;
        this.isAllOrdersReportLoading = false;
        this.setDefaultValues();
    });
}


/**
     * To download CSV or Print file from response data
     * @param  {string} type
     * @returns void
     */
 download(type: string): void {
    const allOrdersReportLength = this.allOrdersReport && this.allOrdersReport.length ?
        this.allOrdersReport && this.allOrdersReport.length : null;
    if (allOrdersReportLength > 0) {
        const columns = [
            this._translateService.get('bsn-reports.Country/Store')['value'],
            this._translateService.get('bsn-reports.BSN Added Date')['value'],
            this._translateService.get('bsn-reports.FBO ID')['value'],
            this._translateService.get('bsn-reports.BSN')['value'],
            this._translateService.get('bsn-reports.Date Of Birth')['value'],
        ];
        const title = this._translateService.get('BSN_Reports')['value'] + "_" + this.fromDate + this._translateService.get('reports._To_')['value'] + this.toDate;
        if (type === this.csvType) {
            this.downloadCSV(columns, allOrdersReportLength);
        } else if (type === this.printType) {
            this.printReportDetails(title, columns, allOrdersReportLength);
        }
    }
}


/**
     * CSV file download functionality
     */
 downloadCSV(columns: any, allOrdersReportLength: any) {
    let rowdata = new Array<any>();
    const finalrows = new Array<any>();
    for (let i = 0; i < allOrdersReportLength; i++) {
        rowdata = [];
        const row = this.allOrdersReport[i];
        rowdata.push(this.countryName ? this.countryName : '')
        rowdata.push(row.createdDate ? (String.fromCharCode(39) + row.createdDate) : '');
        rowdata.push(row.distributorId ? (String.fromCharCode(39) + row.distributorId) : '');
        rowdata.push(row.bsn ? row.bsn : '');
        rowdata.push(row.dob ? (String.fromCharCode(39) + row.dob) : '');
        finalrows.push(rowdata);
    }
    this._customerservice.ExcelDownload(columns, finalrows, 'BSN_Reports', '', false);


}

 /**
     * Print functionality for report details printing
     */
  printReportDetails(title: string, columns: any, allOrdersReportLength: any) {
    let rowdataForPrint = new Array<any>();
    const finalrowsForPrint = new Array<any>();
    for (let i = 0; i < allOrdersReportLength; i++) {
        rowdataForPrint = [];
        const rowForPrint = this.allOrdersReport[i];
        rowdataForPrint.push(this.countryName ? this.countryName : '')
        rowdataForPrint.push(rowForPrint.createdDate ? rowForPrint.createdDate : '');
        rowdataForPrint.push(rowForPrint.distributorId ? rowForPrint.distributorId : '');
        rowdataForPrint.push(rowForPrint.bsn ? rowForPrint.bsn : '');
        rowdataForPrint.push(rowForPrint.dob ? rowForPrint.dob : '');
        finalrowsForPrint.push(rowdataForPrint);
    }
    this._customerservice.constructTableAndPrint(columns, finalrowsForPrint, title);
}



}


// WEBPACK FOOTER //
// ./src/app/customerservice/components/reports/bsn-report.component.ts